var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "look",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 16.204 10.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4093",
    "data-name": "Path 4093",
    d: "M16.167,42.5q-.008-.021-.018-.042A8.928,8.928,0,0,0,.064,42.439a.562.562,0,0,0-.008.5,8.928,8.928,0,0,0,16.093,0A.563.563,0,0,0,16.167,42.5ZM8.1,46.878A7.852,7.852,0,0,1,1.191,42.7a7.805,7.805,0,0,1,13.823,0A7.853,7.853,0,0,1,8.1,46.878Z",
    transform: "translate(-0.001 -37.397)",
    fill: "#003975"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4094",
    "data-name": "Path 4094",
    d: "M77.757,75.291a2.465,2.465,0,1,0,2.465,2.465A2.467,2.467,0,0,0,77.757,75.291Zm0,3.806A1.341,1.341,0,1,1,79.1,77.756,1.343,1.343,0,0,1,77.757,79.1Z",
    transform: "translate(-69.655 -72.454)",
    fill: "#003975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show_password.a28692590f82ed114d1be552a78502ab.svg";
export { ForwardRef as ReactComponent };